/**
 * @fileoverview GET handler for the "/engagement/segment_stats" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentStats } from "./constants";
import type { SegmentStats } from "./types";
import type { GetEngagementSegmentStatsProps } from "./types";

export const getSegmentStats = reactQueryFetcherAdapter(
  engagementSegmentStats,
  (
    signal: AbortSignal,
    { segmentId, type, appGroupId, start, end }: GetEngagementSegmentStatsProps
  ): Promise<SegmentStats> => {
    return fetch(
      `/engagement/segment_stats`,
      "GET",
      { segment_id: segmentId, type: type, app_group_id: appGroupId, start_date: start, end_date: end },
      { signal }
    );
  }
);
